var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3635 17.044C17.5338 17.8532 16.4207 18.3061 15.2617 18.3061C14.1028 18.3061 12.9897 17.8532 12.16 17.044L18.3635 10.9561C19.1932 10.1469 20.3063 9.69391 21.4653 9.69391C22.6243 9.69391 23.7373 10.1469 24.567 10.9561L18.3635 17.044ZM3.38566 17.044L9.57868 10.9561C10.4084 10.1469 11.5215 9.69391 12.6804 9.69391C13.8394 9.69391 14.9525 10.1469 15.7822 10.9561L9.57868 17.044C8.74834 17.8519 7.6355 18.304 6.47692 18.304C5.31834 18.304 4.20548 17.8519 3.37515 17.044H3.38566ZM13.9685 8.90432e-06C11.2007 0.00624527 8.4968 0.832766 6.19855 2.37513C3.9003 3.91748 2.1108 6.10647 1.05616 8.66548C0.00152466 11.2245 -0.27092 14.0387 0.273256 16.7525C0.817433 19.4663 2.15381 21.9579 4.11352 23.9125C6.07323 25.867 8.56833 27.1969 11.2835 27.7339C13.9988 28.271 16.8122 27.9911 19.3685 26.9298C21.9247 25.8684 24.109 24.0732 25.6453 21.7709C27.1816 19.4686 28.001 16.7626 28 13.9948C27.9944 10.2785 26.5131 6.7165 23.8819 4.09212C21.2506 1.46775 17.6848 -0.00417717 13.9685 8.90432e-06Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.491ae33b.svg";
export { ForwardRef as ReactComponent };